import gql from 'graphql-tag';

export const ASSET_VALUE_KEYS = gql`
    query AssetValueKeys($ticker: String!) {
        mutualFund(ticker: $ticker) {
            trpCode
            netAssetsAsOfDate
            correspondingFund {
                trpCode
            }
            twelveMonthHighPrice {
                price
            }
            twelveMonthLowPrice {
                price
            }
            inceptionDate
            price {
                priceChange
                pricePercentChange
                price
                asOfDate
            }
        }
    }
`;
export const ETF_ASSET_VALUE_KEYS = gql`
    query ETFAssetValueKeys($ticker: String!) {
        exchangeTradedFund(ticker: $ticker) {
            trpCode
            inceptionDate
            averageAnnualTotalReturns {
                quarterly {
                    asOfDate
                }
            }
            price {
                priceChange: navPriceChange
                pricePercentChange: navPricePercentChange
                price: navPrice
                asOfDate
            }
        }
    }
`;
